import { useEffect, useRef, useState } from "react";
import styles from "./HeroSectionDesktopStyles.module.scss";
import RecentlySearched from "./components/RecentlySearched";
import SearchInputHome from "./components/SearchInputHome";
import SmallFeatures from "./components/SmallFeatures";
// import StaticNav from "./components/StaticNav";
import useToggleShowNavbar from "hooks/useToggleShowNavbar";
import { AppState } from "@Store/index";
import { shallowEqual, useSelector } from "react-redux";
import Image from "@Components/Image";
import config from "@Config/index";
import HeaderDesktop from "@Components/Header/HeaderDesktop";
import NavSearchInput from "@Components/NavSearchInput";
import { PAGE } from "constants/configConstants";
import useTranslationHook from "hooks/useTranslationHook";
import useIsTabletPortrait from "hooks/useIsTabletPortrait";
import wrapperHOC from "@Utils/wrapperHOC";
import { AMBER_USER_WEBSITE_CONFIGURABLE_COMPONENTS } from "constants/index";
// import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { SCREEN_SIZE, useResponsiveness } from "hooks/useResponsiveness";
import StaticNav from "../HeroSection/components/StaticNav";
// import TextSlidingBanner from "@Components/TextSlidingBanner";
// import Constants from "../../../../locales/langConstants.json";

const HeroSectionDesktop = () => {
  const heroSectionRef: any = useRef();
  const [isSearchScrolledUp, setIsSearchScrolledUp] = useState(false);
  const { t } = useTranslationHook();
  const isTabletPortrait = useIsTabletPortrait();
  const { isAbove } = useResponsiveness();
  const isAboveMD = isAbove(SCREEN_SIZE.MD, false);
  const isFirstRender = useRef(true);
  useToggleShowNavbar(heroSectionRef, setIsSearchScrolledUp);

  const { searchViewedFlag, configComponents } = useSelector(
    ({ appData }: AppState) => ({
      searchViewedFlag: appData.searchViewedFlag,
      isTablet: appData.isTablet,
      configComponents: appData.configComponents,
    }),
    shallowEqual,
  );

  const homePageFestBG = configComponents?.filter(
    (configComponent: any) =>
      configComponent?.component_name ==
        AMBER_USER_WEBSITE_CONFIGURABLE_COMPONENTS["home_page_top_banner"] &&
      configComponent?.data?.title?.text === "amber-fest",
  )?.[0];

  //  constant for now, will remove later once isTablet error is fixed
  const isTablet = false;
  const recentlyVisitedClassName =
    searchViewedFlag === true ? styles.heroRecentlySearchedSectionFixedHeight : "";

  const getHeroImageSrc = () => {
    if (homePageFestBG) {
      if (config.IS_CHINA_APP) return `${config.IMAGE_STATIC_URL}/images/china_bg_amber_sale.jpg`;

      return `${config.IMAGE_STATIC_URL}/images/bg_amber_sale.jpg`;
    }

    if (config.IS_CHINA_APP) {
      return `${config.IMAGE_STATIC_URL}/images/${
        isTablet ? "hero-china-tab" : "hero-china-laptop"
      }.jpg?auto=format&q=60`;
    }

    return `${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/${
      isTablet ? "768 - tab-min" : "1440 - web-min"
    }.png?q=90`;
  };

  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  const renderHeader = () => {
    if (isFirstRender.current || isSearchScrolledUp) {
      return <div style={{ height: "62px" }} />;
    }
    if (isAboveMD) {
      return <HeaderDesktop hideSearchBar transparentBg parentPage={PAGE.HOME} />;
    }
    return <StaticNav />;
  };

  return (
    <>
      {/* {config?.IS_CHINA_APP && <TextSlidingBanner />} */}
      {isSearchScrolledUp &&
        (isTabletPortrait ? (
          <NavSearchInput />
        ) : (
          <HeaderDesktop parentPage={PAGE.HOME} hideLanguageModal />
        ))}

      <div
        id="section-featured"
        className={styles.sectionFeaturedContainer}
        style={{ height: isTablet ? "420px" : "450px" }}
      >
        {renderHeader()}
        <Image
          src={getHeroImageSrc()}
          alt="hero banner"
          height="100%"
          width="100%"
          className={styles.heroImg}
          isEagerLoad
          dataTestId="hero-image"
        />
        <div className={styles.overlayBg} />
        <div className={styles.content}>
          {
            // commenting for fest 15th june 2026
            /* {homePageFestBG && (
            <div
              className={formatClassNames( 
                styles.imageContainer,
                config.IS_CHINA_APP && styles.chinaStyles,
              )}
            >
              <Image
                src={isChinaSite(
                  "https://static-assets.amberstudent.com/images/amber-fiesta.png?h=36&w=177",
                )}
                alt="right-section-desktop"
                width="100%"
                height="auto"
                isEagerLoad
              />
            </div>
          )} */
          }
          <div className={styles.contentInner}>
            <div className={styles.heroTitleSection}>
              <h2 className={styles.heroTitle} data-testid="hero-image-main-text">
                {t("home.herosection.titlestring")}
              </h2>
              <h1 className={styles.heroSubTitle} data-testid="hero-image-sub-text">
                {t("home.herosection.subtitlestring")}
              </h1>
              <SmallFeatures dataTestId="heroImage-smallFeatures" />
            </div>
            <div className={styles.heroSearchSection} ref={heroSectionRef}>
              <SearchInputHome />
            </div>
            <div className={recentlyVisitedClassName}>
              <RecentlySearched />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default wrapperHOC(HeroSectionDesktop, {
  componentName: "HeroSectionDesktop-Home",
  showForChina: true,
});
